import { getPolygonHeadings } from 'common/components/segment/asceHelpers';
import { normalizeRailSpacing } from 'common/utils/helpers/systemsValues';

import { INITIALIZE_VALUES } from '../actionTypes';
import { panelLayoutV2Actions } from '../reducer';

export default (values, google) => (dispatch) => {
    const polygonHeadings = getPolygonHeadings({
        google,
        polygonCoords: values.polygon,
    });

    const azimuthSelectorValue = polygonHeadings.filter(
        ({ heading }) => parseFloat(heading) === parseFloat(values.azimuth),
    );
    let azimuth_selector = 'custom';

    if (azimuthSelectorValue.length > 0) {
        azimuth_selector = azimuthSelectorValue[0].heading;
    }
    const { rail_spacing } = values;
    const normalized_rail_spacing = {
        ...rail_spacing,
        value: normalizeRailSpacing(rail_spacing),
    };
    dispatch(
        panelLayoutV2Actions[INITIALIZE_VALUES]({
            ...values,
            azimuth_selector,
            rail_spacing: normalized_rail_spacing,
        }),
    );
};
